export default __webpack_public_path__ + "static/media/Akshay.5ccd0cf2.png";